import { CheckCircle } from "@phosphor-icons/react";
import { useState } from "react";

/**
 * The first fortnight, said plainly. Bands need the member's own days behind
 * them, so until there are enough the page withholds them and says how far
 * along it is, rather than drawing a confident range over five days.
 *
 * The question is the one thing a member can do about it: a wearable cannot
 * report whether they felt rested, so an answer is a reading the page could not
 * otherwise have.
 */
export function SnapshotGathering({
  day,
  need,
  reporting,
  total,
  onAnswer,
}: {
  day: number;
  need: number;
  reporting: number;
  total: number;
  /** Records the answer as a check-in. Undefined leaves the question off. */
  onAnswer?: (rested: boolean) => void;
}) {
  const [answered, setAnswered] = useState(false);
  return (
    <div className="snap-gather">
      <p className="snap-gather-day">
        Day {day} of {need} · your usual ranges are still forming
      </p>
      <span
        className="snap-gather-petals"
        role="img"
        aria-label={`Day ${day} of ${need} baseline days complete; ${reporting} of ${total} signal kinds reporting.`}
      >
        {Array.from({ length: need }, (_, i) => i + 1).map((n) => (
          <i
            key={n}
            className={n <= day ? "is-on" : undefined}
            style={{ transform: `rotate(${(n - 1) * (360 / need)}deg) translateY(-11px)` }}
          />
        ))}
        <b>{day}</b>
      </span>
      {onAnswer ? (
        answered ? (
          <p className="snap-gather-done">
            <CheckCircle size={14} aria-hidden="true" />
            Logged. Answers like this sharpen your usual ranges.
          </p>
        ) : (
          <div className="snap-gather-q">
            <span>Did you feel rested this morning?</span>
            <span className="snap-gather-btns">
              <button
                type="button"
                onClick={() => {
                  setAnswered(true);
                  onAnswer(true);
                }}
              >
                Yes
              </button>
              <button
                type="button"
                onClick={() => {
                  setAnswered(true);
                  onAnswer(false);
                }}
              >
                No
              </button>
            </span>
          </div>
        )
      ) : null}
    </div>
  );
}
